<template>
    <NuxtLink 
      v-if="entry && entry.images.primary && (entry.images.primary.lg.alt || entry.altText || entry?.description)"
      :to="entry.cta.url" :external="true"
      class="simple-banner entry"
    >
      <div class="flex flex-col items-center">
        <div><img fetchpriority="high" :src="entry.images.primary.lg.url" :alt="entry.images.primary.lg.alt && entry.images.primary.lg.alt != '' ? entry.images.primary.lg.alt : entry.altText && entry.altText != '' ? entry.altText : entry?.description"></div>
      </div>
    </NuxtLink>
</template>
<script setup lang="ts">
import type { SliderEntry } from '../../SliderStructure';
defineProps<{
  entry: SliderEntry;
}>();
</script>
<style lang="postcss" scoped>
  .entry {
    @apply rounded-3xl overflow-hidden items-center grid h-full lg:h-[500px];
  }
</style>